// extracted by mini-css-extract-plugin
export default {"QuerySingleTable":"QuerySingleTable---rTXS2","ResultsSummary":"ResultsSummary---JwhxP"};